import { CalendarView } from "../types";

export const convertStringToCalendarView = (
  str: string,
  defaultView: CalendarView = "month"
): CalendarView | undefined => {
  switch (str) {
    case "month":
    case "year":
    case "day":
    case "list":
    case "week":
      return str as CalendarView;
    default:
      return defaultView;
  }
};
